import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-coupon-preview',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './coupon-preview.component.html',
  styleUrls: ['./coupon-preview.component.scss'],
})
export class CouponPreviewComponent {

  @Input() form!: FormGroup;
  @Input() selectedStore: any[] = [];
  @Input() selectedCategory: any[] = [];
  @Input() membershipList: any[] = [];

  // 🔥 helper for template clean usage
  get f() {
    return this.form?.controls;
  }

  get selectedTier(): any {
    const tierId = this.form?.get('membershipTierId')?.value;
    if (!tierId || !this.membershipList?.length) return null;
    return this.membershipList.find((m: any) => m.id == tierId) || null;
  }
}